import React, { useRef, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';
import { Loader2, AudioLines, NotebookPen } from 'lucide-react';
import { MicButton } from '../voice/VoiceControls';
import { runAiJob } from '../../lib/aiJob';

const btn = 'text-xs font-semibold rounded-lg border px-3 py-2 flex items-center justify-center gap-1.5';

export const MatterVoiceTools = ({ matter, onUpdated }) => {
  const { api } = useAuth();
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [summary, setSummary] = useState(null);

  const saveNote = async (text) => {
    try {
      await api.post('/crm/activities', { client_id: matter.client_id, matter_id: matter.id, activity_type: 'note', title: 'Nota por voz', description: text });
      toast.success('Nota por voz guardada en el caso');
      onUpdated();
    } catch { toast.error('No se pudo guardar la nota'); }
  };
  const upload = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = '';
    if (!f) return;
    if (f.size > 25 * 1024 * 1024) return toast.error('El audio supera 25 MB');
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', f);
      fd.append('label', 'Audiencia');
      const { data } = await api.post(`/crm/matters/${matter.id}/hearing-recording`, fd);
      const rec = await runAiJob(api, null, null, { jobId: data.job_id, timeout: 600000 });
      setSummary(rec.summary);
      toast.success('Audiencia transcrita y agregada a los documentos del caso');
      onUpdated();
    } catch (er) { toast.error(er.response?.data?.detail || er.message || 'No se pudo transcribir la audiencia'); } finally { setBusy(false); }
  };

  return (
    <div className="mt-2 space-y-2">
      <div className="grid grid-cols-2 gap-2">
        <div className={`${btn} border-slate-600 text-slate-300`}>
          <NotebookPen className="w-3.5 h-3.5" />Nota por voz
          <MicButton testid={`matter-voice-note-${matter.id}`} onText={saveNote} className="!px-2 !py-1" />
        </div>
        <button data-testid={`matter-hearing-audio-btn-${matter.id}`} onClick={() => fileRef.current?.click()} disabled={busy} className={`${btn} border-cyan-500/40 text-cyan-300 hover:bg-cyan-500/10 disabled:opacity-50`}>
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <AudioLines className="w-3.5 h-3.5" />}{busy ? 'Transcribiendo...' : 'Transcribir audiencia'}
        </button>
        <input ref={fileRef} data-testid={`matter-hearing-audio-input-${matter.id}`} type="file" accept=".mp3,.m4a,.wav,.webm,.mp4,.ogg,audio/*" className="hidden" onChange={upload} />
      </div>
      {summary && <div data-testid={`matter-hearing-summary-${matter.id}`} className="text-xs whitespace-pre-wrap bg-slate-900 border border-slate-700 rounded-lg p-3 text-slate-300 max-h-60 overflow-y-auto">{summary}</div>}
    </div>
  );
};
